import { render, staticRenderFns } from "./FooterBanks.vue?vue&type=template&id=4e9bd82a&"
import script from "./FooterBanks.vue?vue&type=script&lang=js&"
export * from "./FooterBanks.vue?vue&type=script&lang=js&"
import style0 from "./FooterBanks.vue?vue&type=style&index=0&id=4e9bd82a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports